// accordion
class Accordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.accordions = this.querySelectorAll("[accordion-item]");

        this.accordions.forEach((accordion) => {
            const header = accordion.querySelector("[header]");
            const content = accordion.querySelector("[content]");
            const height = content.firstElementChild.scrollHeight;

            
            header.addEventListener("click", (e) => {
                this.collapseOthers(accordion);
                if(accordion.classList.contains("active")){
                    accordion.classList.remove("active");
                    content.style.height = 0;
                }else{
                    accordion.classList.add("active");
                    content.style.height = `${height}px`;
                }
            })
        })
    }

    collapseOthers(accordion){
        this.accordions.forEach((item) => {
            if(item !== accordion){
                item.classList.remove("active");
                item.querySelector("[content]").style.height = 0;
            }
        })
    }
}

customElements.define("accordion-wrapper", Accordion);


// collection swiper
class CollectionSwiper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const prev = this.querySelector(".swiper-button-prev");
        const next = this.querySelector(".swiper-button-next");

        this.swiper = new Swiper(this, {
            slidesPerView: 2.2,
            spaceBetween: 10,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
            },
        });
    }

    disconnectedCallback() {
        this.swiper.destroy();
    }
}

customElements.define("collection-swiper", CollectionSwiper);


// product gallery

class ProductGallery extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const mainSwiper = this.querySelector("[main-swiper]");
        const thumbSwiper = this.querySelector("[thumb-swiper]");
        const lightboxOpener = this.querySelector("[lightbox-opener]");
        const lightbox = this.querySelectorAll("[lightbox] a");
        const shareBtn = this.querySelector("[share-btn]")

        this.swiper2 = new Swiper(thumbSwiper, {
            spaceBetween: 30,
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
        });

        this.swiper = new Swiper(mainSwiper, {
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            thumbs: {
                swiper: this.swiper2,
            },
            on: {
                init: (swiper) => {
                    this.autoplayActiveSlide(swiper);
                },
                slideChange: (swiper) => {
                    this.autoplayActiveSlide(swiper);
                },
            },
        });

        lightboxOpener.addEventListener("click", (e) => {
            lightbox[this.swiper.activeIndex].click();
        });

        shareBtn.addEventListener("click", (e) => {
            const link = shareBtn.getAttribute("share-link");
            navigator.clipboard.writeText(link);
        });
    }

    autoplayActiveSlide(swiper) {
        swiper.slides.forEach((slide, index) => {
            const isActive = index === swiper.activeIndex;

            const video = slide.querySelector("video");
            if (video) {
            isActive ? video.play() : video.pause();
            }

            const iframe = slide.querySelector("iframe");
            if (iframe && iframe.src.includes("youtube")) {
            iframe.contentWindow.postMessage(
                JSON.stringify({
                event: "command",
                    func: isActive ? "playVideo" : "pauseVideo",
                }),
                "*"
            );
            }
        });
    }

    disconnectedCallback() {
        this.swiper.destroy();
        this.swiper2.destroy();
    }
}

customElements.define("product-gallery", ProductGallery);

// load event 

document.addEventListener('DOMContentLoaded', function () {
  loadLoader();
});
document.addEventListener('shopify:section:load', function () {
  loadLoader();
});

function loadLoader() {
    // product cards buy btns
    const productCards = document.querySelectorAll(".jb_product_card");

    productCards.forEach((card)=>{
        const buyBtns = card.querySelectorAll("button[buy-button]");
        const mainBtn = card.querySelector(".quick-add button");

        buyBtns.forEach((button)=>{
            button.addEventListener("click", ()=>{
                mainBtn.click();
            })
        })
    });


    // pricing modal
    const pmOpener = document.querySelector(".purchase_type .title_box .icon_box");
    const pnCloser = document.querySelector(".purchase_type .jb_pricing_modal .close_btn");
    const pnModal = document.querySelector(".purchase_type .jb_pricing_modal");

    pmOpener?.addEventListener("click", () => {
        pnModal.classList.add("active"); // open
    });

    pnCloser?.addEventListener("click", () => {
        pnModal.classList.remove("active"); // close
    });

    pnModal?.addEventListener("click", (e) => {
        if (e.target === pnModal) {
        pnModal.classList.remove("active");
        }
    });


    // more details
    const moreDeatilsBtn = document.querySelector(".jb_product_info .description_box .full_details");
    const description = document.querySelector(".jb_product_info .description_box .description");
    const descriptionLists = document.querySelectorAll(".jb_product_info .description_box .description li");

    if(descriptionLists?.length < 2 && moreDeatilsBtn){
        moreDeatilsBtn.style.display = "none";
    }

    moreDeatilsBtn?.addEventListener("click", (e) => {
        if (description.classList.contains("active")) {
            description.classList.remove("active");
            moreDeatilsBtn.innerHTML = "View full item details";
        } else {
            description.classList.add("active");
            moreDeatilsBtn.innerHTML = "View less item details";
        }
    });


    // jb wishlist
    const wishlistBtn = document.querySelector(".product_gallery_wrapper .jb_wishlist_button");


    setTimeout(() => {
        const wishlistBtnMain = document.querySelector("#swym-atw-button-container #swym-atw-pdp-button");

        if(wishlistBtnMain?.classList.contains("atw-button-added")){
            wishlistBtn?.classList.add("active");
        } else {
            wishlistBtn?.classList.remove("active");
        }
    }, 2000);

    wishlistBtn?.addEventListener("click", ()=>{
        const wishlistBtnMain = document.querySelector("#swym-atw-button-container #swym-atw-pdp-button");
        wishlistBtnMain.click();
        if(wishlistBtnMain?.classList.contains("atw-button-added")){
            wishlistBtn?.classList.remove("active");
        } else {
            wishlistBtn?.classList.add("active");
        }
    });


    buyWithPrime();


    // swatch
    swatchInit();
}

function swatchInit(){
    const swatchs = document.querySelectorAll("variant-selects .fs-swatch-label");
    const thumbs = document.querySelectorAll(".thumb_slider[thumb-swiper] .swiper-slide");
    const pagination = document.querySelectorAll(".main_slider[main-swiper] .swiper-pagination .swiper-pagination-bullet");

    
    if(swatchs && thumbs &&  pagination){
        swatchs.forEach((swatch)=>{
            swatch.addEventListener("click", ()=>{
                const MediaID = swatch.getAttribute("selected-variant-id");
                thumbs.forEach((thumb, index)=>{
                    if(MediaID === thumb.getAttribute("media-id")){
                        pagination[index].click();
                    }
                })
            })
        })
    }
}


function buyWithPrime() {
  const stylePrime = () => {
    const wrapper = document.querySelector("delivery-promise-wc");
    if (!wrapper || !wrapper.shadowRoot) return false;

    // Prevent duplicate styling
    if (wrapper.shadowRoot.adoptedStyleSheets.some(s => s._custom)) return true;

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      .BuyWithPrimeButton__buy-with-prime-button{
        border-radius: 40px;
      }
    `);

    sheet._custom = true;
    wrapper.shadowRoot.adoptedStyleSheets = [
      ...wrapper.shadowRoot.adoptedStyleSheets,
      sheet
    ];

    return true;
  };

  // Keep retrying until the element is ready, then stop
  const interval = setInterval(() => {
    if (stylePrime()) clearInterval(interval);
  }, 500);
}